import { render } from "./itemSlider.vue?vue&type=template&id=a269f47a&scoped=true"
import script from "./itemSlider.vue?vue&type=script&lang=js"
export * from "./itemSlider.vue?vue&type=script&lang=js"

import "./itemSlider.vue?vue&type=style&index=0&id=a269f47a&scoped=true&lang=css"

import exportComponent from "C:\\CEDIS\\cedispage2.0_general_guvi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a269f47a"]])

export default __exports__